"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ErrorIcon = function ErrorIcon() {
  return _react2.default.createElement(
    "svg",
    { width: "85px", height: "85px", viewBox: "0 0 85 85", version: "1.1" },
    _react2.default.createElement(
      "g",
      { stroke: "none", strokeWidth: "1", fill: "none", fillRule: "evenodd" },
      _react2.default.createElement(
        "g",
        { transform: "translate(-146.000000, -124.000000)" },
        _react2.default.createElement(
          "g",
          { transform: "translate(20.000000, 116.000000)" },
          _react2.default.createElement(
            "g",
            { transform: "translate(118.000000, 0.000000)" },
            _react2.default.createElement(
              "g",
              { transform: "translate(8.333333, 8.333333)" },
              _react2.default.createElement("circle", { stroke: "#FF0A28", fillRule: "nonzero", cx: "41.6666667", cy: "41.6666667", r: "41.1666667" }),
              _react2.default.createElement("path", {
                d: "M50.0884184,29.9124663 C50.4923339,29.535809 51.1251132,29.5579062 51.5017705,29.9618217 L51.5017705,29.9618217 L54.5139884,33.1920299 C54.8906457,33.5959454 54.8685485,34.2287247 54.464633,34.605382 L54.464633,34.605382 L46.3702129,42.1523343 L54.464633,49.7001736 C54.8685485,50.0768309 54.8906457,50.7096102 54.5139884,51.1135257 L51.5017705,54.3437339 C51.1251132,54.7476494 50.4923339,54.7697465 50.0884184,54.3930892 L41.6662129,46.5393343 L33.2449149,54.3930892 C32.8720698,54.7407729 32.3042166,54.7486894 31.9228096,54.4301596 L31.8315629,54.3437339 L28.819345,51.1135257 C28.4426877,50.7096102 28.4647848,50.0768309 28.8687003,49.7001736 L28.8687003,49.7001736 L36.9622129,42.1523343 L28.8687003,34.605382 C28.4647848,34.2287247 28.4426877,33.5959454 28.819345,33.1920299 L31.8315629,29.9618217 C32.2082201,29.5579062 32.8409994,29.535809 33.2449149,29.9124663 L41.6662129,37.7653343 Z",
                fill: "#FF0A28"
              })
            )
          )
        )
      )
    )
  );
};

exports.default = ErrorIcon;